import React, { useState, useEffect } from 'react'
import { Panel, Row, Col, Input, SelectPicker, Checkbox, Message, Icon } from 'rsuite'

import { isRequired, isValidators, requiredFiled } from '../../utils/ValidatorUtils'
import ErrorMessage from '../../components/message/errorMessage/ErrorMessage'
import { values } from 'lodash'
import './styles.less'

export default function SubProjectForm({
  schema: _schema,
  register,
  errors,
  error,
  Controller,
  control,
  setValue,
  clearErrors,
  getValues,
  handelPreview,
  onSelectSubproject,
  ...props
}) {
  const [schema, setSchema] = useState(_schema)
  const [selectSubProject, setSelectSubProject] = useState([])

  useEffect(() => {
    setSchema(_schema)
  }, [_schema])

  // useEffect(() => {
  //   if (schema.values) {
  //     let panelArr = []
  //     schema.values.map((values) => {
  //       const { isSelectSubProjectValue } = values
  //       panelArr.push(isSelectSubProjectValue)
  //     })
  //     setSelectSubProject(panelArr)
  //   }
  // }, [])

  // const handelSelectSubProject = (index, value) => {
  //   const oldArr = selectSubProject
  //   setSelectSubProject([])
  //   oldArr.forEach(() => (oldArr[index] = value))
  //   setSelectSubProject(oldArr)
  // }

  return (
    <>
      {schema.values.map((object, index) => {
        const {
          activityValue,
          actualResultValue,
          isSelectSubProjectValue,
          planResultValue,
          problemValue,
          progressiveStatusValue,
          projectCode,
          projectId,
          projectNameEN,
          projectNameTH,
        } = object

        return (
          <>
            <br />
            <Panel
              key={index}
              bordered
              collapsible={false}
              defaultExpanded
              // style={{ backgroundColor: '#c5cfcc1a' }}
              className="rs-panel-bordered-sty"
            >
              <div style={{ display: 'none' }}>
                <Input
                  key={`${index}_projectId`}
                  name={`subProject[${index}].subProjectId`}
                  defaultValue={projectId}
                  inputRef={register()}
                />
              </div>
              <Row>
                <Col lg={24} md={24} sm={24} xs={24} style={{ marginTop: '5px', padding: '8px' }}>
                  {!isSelectSubProjectValue && (
                    <Message
                      showIcon
                      type="warning"
                      description={'กรุณาเลือกโครงการก่อนทำการบันทึกรายงานความก้าวหน้า'}
                    />
                  )}
                </Col>
              </Row>
              <Row>
                <Col lg={12} md={12} sm={24} xs={24} style={{ marginTop: '5px', padding: '8px' }}>
                  <Controller
                    key={`${index}_${schema.isSelectSubProject.name}`}
                    name={`subProject[${index}].${schema.isSelectSubProject.name}`}
                    // defaultValue={isSelectSubProjectValue}
                    control={control}
                    render={(props) => {
                      return (
                        <Checkbox
                          checked={props.defaultValue}
                          defaultChecked={isSelectSubProjectValue}
                          style={{ marginTop: '-12px', paddingLeft: '5%' }}
                          onChange={(value, checked) => {
                            props.onChange(checked)
                            setValue(`${index}_isSelectSubProjectValue`)

                            // handelSelectSubProject(index, checked)
                            onSelectSubproject(index)
                          }}
                        >
                          {`${index + 1}. โครงการ :  `}
                          {projectCode && (
                            <b style={{ paddingRight: '5px', color: '#2da888' }}>{projectCode}</b>
                          )}

                          {projectNameTH && (
                            <b style={{ paddingRight: '5px', color: '#2da888' }}>{projectNameTH}</b>
                          )}

                          {projectNameEN && (
                            <b style={{ paddingRight: '5px', color: '#2da888' }}>{projectNameEN}</b>
                          )}
                        </Checkbox>
                      )
                    }}
                  />
                </Col>

                {schema.progressiveStatus && (
                  <>
                    <Col
                      lg={3}
                      md={3}
                      sm={5}
                      xs={5}
                      style={{
                        marginTop: '5px',
                        padding: '8px',
                        textAlign: 'right',
                      }}
                    >
                      {schema.progressiveStatus.label}
                    </Col>
                    <Col lg={9} md={9} sm={19} xs={19} style={{ marginTop: '5px', padding: '8px' }}>
                      <Controller
                        key={`${index}_${schema.progressiveStatus.name}`}
                        name={`subProject[${index}].status`}
                        control={control}
                        defaultValue={progressiveStatusValue}
                        render={(props) => {
                          return (
                            <SelectPicker
                              data={schema.progressiveStatus.options}
                              disabled={!isSelectSubProjectValue}
                              searchable={false}
                              value={props.value}
                              block
                              placeholder="เลือก"
                              onChange={(value) => {
                                props.onChange(value)
                              }}
                            />
                          )
                        }}
                      />
                    </Col>
                  </>
                )}
              </Row>

              <Row>
                {schema.activity && (
                  <>
                    <Col
                      lg={3}
                      md={3}
                      sm={5}
                      xs={5}
                      style={{
                        marginTop: '5px',
                        padding: '8px',
                        textAlign: 'right',
                      }}
                    >
                      {schema.activity.label}
                    </Col>
                    <Col lg={9} md={9} sm={19} xs={19} style={{ marginTop: '5px', padding: '8px' }}>
                      <Input
                        key={`${index}_${schema.activity.name}`}
                        name={`subProject[${index}].${schema.activity.name}`}
                        disabled={!isSelectSubProjectValue}
                        defaultValue={activityValue}
                        componentClass="textarea"
                        placeholder={schema.activity.label}
                        inputRef={register(isValidators(schema.activity.validators))}
                      />
                    </Col>
                  </>
                )}

                {schema.planResult && (
                  <>
                    <Col
                      lg={3}
                      md={3}
                      sm={5}
                      xs={5}
                      style={{
                        marginTop: '5px',
                        padding: '8px',
                        textAlign: 'right',
                      }}
                    >
                      {schema.planResult.label}
                    </Col>
                    <Col lg={9} md={9} sm={19} xs={19} style={{ marginTop: '5px', padding: '8px' }}>
                      <Input
                        key={`${index}_${schema.planResult.name}`}
                        name={`subProject[${index}].${schema.planResult.name}`}
                        defaultValue={planResultValue}
                        disabled={!isSelectSubProjectValue}
                        componentClass="textarea"
                        placeholder={schema.planResult.label}
                        inputRef={register(isValidators(schema.planResult.validators))}
                      />
                    </Col>
                  </>
                )}
              </Row>

              <Row>
                {schema.actualResult && (
                  <>
                    <Col
                      lg={3}
                      md={3}
                      sm={5}
                      xs={5}
                      style={{
                        marginTop: '5px',
                        padding: '8px',
                        textAlign: 'right',
                      }}
                    >
                      {schema.actualResult.label}
                    </Col>
                    <Col lg={9} md={9} sm={19} xs={19} style={{ marginTop: '5px', padding: '8px' }}>
                      <Input
                        key={`${index}_${schema.actualResult.name}`}
                        name={`subProject[${index}].${schema.actualResult.name}`}
                        defaultValue={actualResultValue}
                        disabled={!isSelectSubProjectValue}
                        componentClass="textarea"
                        placeholder={schema.actualResult.label}
                        inputRef={register(isValidators(schema.actualResult.validators))}
                      />
                    </Col>
                  </>
                )}

                {schema.problem && (
                  <>
                    <Col
                      lg={3}
                      md={3}
                      sm={5}
                      xs={5}
                      style={{
                        marginTop: '5px',
                        padding: '8px',
                        textAlign: 'right',
                      }}
                    >
                      {schema.problem.label}
                    </Col>
                    <Col lg={9} md={9} sm={19} xs={19} style={{ marginTop: '5px', padding: '8px' }}>
                      <Input
                        key={`${index}_${schema.problem.name}`}
                        name={`subProject[${index}].${schema.problem.name}`}
                        disabled={!isSelectSubProjectValue}
                        defaultValue={problemValue}
                        componentClass="textarea"
                        placeholder={schema.problem.label}
                        inputRef={register(isValidators(schema.problem.validators))}
                      />
                    </Col>
                  </>
                )}
              </Row>
            </Panel>
          </>
        )
      })}
    </>
  )
}
